import React from "react";
import {
  ErrorBoundary,
  SearchProvider,
  SearchBox,
  Results,
  PagingInfo,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch
} from "@elastic/react-search-ui";
import {
  Layout,
} from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import ElasticsearchAPIConnector
from "@elastic/search-ui-elasticsearch-connector";

class Dialogue extends React.Component {

  render() {
    const connector = new ElasticsearchAPIConnector({
    host: "https://localhost:9200",
    index: "test1",
    apiKey: "ZXdicUZaZ0I4U29TSFJSMFp2eHc6MU9XMTQxTXVoOEVqbTdGWThVaDhRZw=="
  });


  const config = {
    debug: true,
    alwaysSearchOnInitialLoad: true,
    apiConnector: connector,
    searchQuery: {
      filters: [],
      search_fields: {
        text: {
          weight: 3
        },
      },
      result_fields: {
        text: {
          snippet: {}
        },
        start: {
          raw: {}
        },
        end: {
          raw: {}
        },
        bgmid: {
          raw: {}
        }

      },
    },
    autocompleteQuery: {
      results: {
        resultsPerPage: 5,
        search_fields: {
          "text.suggest": {
            weight: 3
          }
        },
        result_fields: {
          text: {
            snippet: {
              size: 100,
              fallback: true
            }
          },
        }
      },
      suggestions: {
        types: {
          results: {fields: ["text"]}
        },
        size: 4
      }
    },
  };

  const SORT_OPTIONS = [];
    return (
        <SearchProvider config={config}>
          <WithSearch
              mapContextToProps={({wasSearched}) => ({
                wasSearched
              })}
          >
            {({wasSearched}) => {
              return (
                  <div className="App">
                    <ErrorBoundary>
                      <Layout
                          header={
                            <SearchBox
                                autocompleteMinimumCharacters={3}
                                autocompleteResults={{
                                  linkTarget: "_blank",
                                  sectionTitle: "Results",
                                  titleField: "text",
                                  shouldTrackClickThrough: true
                                }}
                                autocompleteSuggestions={true}
                                debounceLength={0}
                            />
                          }
                          sideContent={
                            <div>

                            </div>
                          }
                          bodyContent={<Results
                              shouldTrackClickThrough={true}/>}
                          bodyHeader={
                            <React.Fragment>
                              {wasSearched && <PagingInfo/>}
                              {wasSearched && <ResultsPerPage/>}
                            </React.Fragment>
                          }
                          bodyFooter={<Paging/>}
                      />
                    </ErrorBoundary>
                  </div>
              );
            }}
          </WithSearch>
        </SearchProvider>
    );
  }
}
export default Dialogue;